<template>
    <el-popover
        placement="right"
        :width="320"
        trigger="hover"
        popper-class="storage-popover"
    >
        <template #reference>
            <PtIcon icon="SolidInfo" class="flex-shrink-0 cursor-pointer text-xl fill-[#BCC2CC] hover:fill-[#8993A4]"></PtIcon>
        </template>
        <template #default>
            <div class="flex flex-col gap-3">
                <div class="text-base font-medium leading-[1.5] text-[#020A1A]">
                    {{ t('storage.tooltip.title') }}
                </div>
                <div class="flex flex-col gap-2">
                    <div class="flex items-center justify-between">
                        <span class="text-sm leading-[1.43] text-[#495973]">{{ t('storage.tooltip.project') }}</span>
                        <span class="text-sm leading-[1.43] text-[#020A1A]">{{ formatStorage(projects?.available || 0) }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                        <span class="text-sm leading-[1.43] text-[#495973]">{{ t('storage.tooltip.reward') }}</span>
                        <span class="text-sm leading-[1.43] text-[#020A1A]">{{ formatStorage(rewardStorage?.available || 0) }}</span>
                    </div>
                </div>
            </div>
        </template>
    </el-popover>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ElPopover } from 'element-plus';
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/info.svg';
import { useLsEditionUsage } from '../../../composables/use-ls-edition-usage';

const messages = {
    en: {
        storage: {
            tooltip: {
                title: 'Available Storage',
                project: 'Project Space',
                reward: 'Reward Space',
            },
        },
    },
    cn: {
        storage: {
            tooltip: {
                title: '可用空间',
                project: '项目空间',
                reward: '奖励空间',
            },
        },
    },
    tw: {
        storage: {
            tooltip: {
                title: '可用空間',
                project: '項目空間',
                reward: '獎勵空間',
            },
        },
    },
    jp: {
        storage: {
            tooltip: {
                title: '利用可能なストレージ',
                project: 'プロジェクトスペース',
                reward: '報酬スペース',
            },
        },
    },
}

const { t } = useI18n({
    messages,
});

const { projects, rewardStorage } = useLsEditionUsage();

/**
 * 格式化存储空间显示（MB 转换为合适的单位）
 * @param mb - 存储空间（MB）
 * @returns 格式化后的字符串
 */
function formatStorage(mb: number): string {
    if (mb >= 1024) {
        return `${(mb / 1024).toFixed(1)} GB`;
    }
    return `${mb} MB`;
}
</script>
